<div class="upload-container" [style.width.px]="size" [style.height.px]="size">
  <div class="image-wrapper" (mouseenter)="isHovered = true" (mouseleave)="isHovered = false"
    (click)="fileInput.click()">

    <!-- Preview or Placeholder -->
    @if (previewUrl) {
      <div class="preview-area">
        <img [src]="previewUrl" alt="Profile preview">
      </div>
    }
    @if (!previewUrl) {
      <div class="placeholder-area">
        <hugeicons-icon [icon]="placeholderIcon" [size]="size * 0.5" color="currentColor"></hugeicons-icon>
      </div>
    }

    <!-- Hover Overlay -->
    <div class="overlay" [class.visible]="isHovered || !previewUrl">
      <hugeicons-icon [icon]="previewUrl ? editIcon : cameraIcon" [size]="24" color="currentColor"></hugeicons-icon>
      <span class="overlay-text">{{ previewUrl ? 'Change' : 'Upload' }}</span>
    </div>
  </div>

  <!-- Clear Button -->
  @if (previewUrl) {
    <button type="button" class="remove-btn" (click)="removeImage($event)" title="Remove image">
      <hugeicons-icon [icon]="closeIcon" [size]="20" color="currentColor"></hugeicons-icon>
    </button>
  }

  <!-- Hidden Input -->
  <input type="file" #fileInput style="display: none;" accept="image/*" (change)="onFileSelected($event)">
</div>